import { TranscodingProfile } from "./transcoding-profile";
import {
  ETranscodingJobPriority,
  ETranscodingJobStatus,
  TranscoderJobDetails,
} from "./transcoder-job";
import { TranscodingDestination } from "./transcoding-destination";
import { TranscodingSideEffect } from "./Transcoding-side-effect";
import { ShakaPackagerJob } from "./shaka-packager-job";
import { CreateShakaPackagerJobsResult } from "./create-shaka-packager-jobs-result";
import { CreateShakaPackagerJobsBulkResult } from "./create-shaka-packager-jobs-bulk-result";
import { ShakaPackagerEligibleMedia } from "./shaka-packager-eligible-media";
import {
  CreateShakaPackagerJobsByMediaResult,
} from "./create-shaka-packager-jobs-by-media-result";

export abstract class IMediaTranscoderRepository {
  abstract getTenantTranscodingDestinations(): Promise<
    TranscodingDestination[]
  >;
  abstract getProfiles(): Promise<TranscodingProfile[]>;
  abstract getJobs(
    statuses: ETranscodingJobStatus[],
  ): Promise<TranscoderJobDetails[]>;
  abstract getTranscodingJobDetails(id: string): Promise<TranscoderJobDetails>;
  abstract getSideEffects(): Promise<TranscodingSideEffect[]>;
  abstract createNewJob(newJob: TranscoderJobDetails): Promise<void>;
  abstract abortJob(jobId: string): Promise<void>;
  abstract changeJobPriority(
    jobId: string,
    newPriority: ETranscodingJobPriority,
  ): Promise<void>;
  abstract getShakaPackagerJobs(): Promise<ShakaPackagerJob[]>;
  abstract getShakaPackagerProcessLog(
    jobUid: string,
  ): Promise<Record<string, unknown>>;
  abstract createShakaPackagerJobs(
    transcodingJobId: string,
    fullMode?: boolean,
  ): Promise<CreateShakaPackagerJobsResult>;
  abstract createShakaPackagerJobsBulk(
    transcodingJobIds: string[],
    fullMode?: boolean,
  ): Promise<CreateShakaPackagerJobsBulkResult>;
  abstract getShakaPackagerEligibleMedia(): Promise<ShakaPackagerEligibleMedia[]>;
  abstract createShakaPackagerJobsByMedia(
    items: { mediaId: number; fullMode: boolean }[],
    options?: { rescheduleExisting?: boolean },
  ): Promise<CreateShakaPackagerJobsByMediaResult>;
}
